const US_COUNTRY_CODE = 1;
const hashEmail = async (email) => {
  if (!email) {
    return null;
  }
  const formattedEmail = email.trim().toLowerCase();
  const result = await digestMessage(formattedEmail);
  return result;
};
const hashPhone = async (phone) => {
  if (!phone) {
    return null;
  }
  const formattedNumber = `${US_COUNTRY_CODE}${phone.replace(/[^.0-9]/g, "")}`;
  const result = await digestMessage(formattedNumber);
  return result;
};
const digestMessage = async (message) => {
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
};
export {
  digestMessage,
  hashEmail,
  hashPhone
};
